module.exports = __webpack_public_path__ + "img/globe1.e7053359.png";